<template>
  <div>
    <!-- form starts -->
    <vue-element-loading
      :active="isSubmitted"
      text="MYLE"
      :text-style="loadStyle"
      :is-full-screen="true"
      class="h-full background-overlay"
      spinner="bar-fade-scale"
      color="#ffffff"
    />

    <!-- model -->
    <nu-modal ref="zmodal">
      <div class="container-fluid" v-if="selected">
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <h3
                class="w-auto d-inline-block"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 700;
                  font-size: 28px;
                "
              >
                Place Your Bid
              </h3>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="flex d-flex"
              style="
                width: 100%;
                justify-content: space-between;
                margin-top: 2rem;
                flex-wrap: wrap;
              "
            >
              <div>
                <p
                  style="
                    margin: 0;
                    color: black;
                    font-weight: bold;
                    font-size: 16px;
                  "
                >
                  Title
                </p>
                <p
                  style="
                    width: 18rem;
                    font-family: 'Quicksand', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                  "
                >
                  {{ selected ? selected.title : "" }}
                </p>
              </div>

              <div class="text-center">
                <p
                  style="
                    margin: 0;
                    color: black;
                    font-weight: bold;
                    font-size: 16px;
                  "
                >
                  Current Bid Value
                </p>
                <p
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-size: 16px;
                    font-weight: 700;
                  "
                >
                  ${{ selected ? selected.currentBidValue : "" }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <label
              style="
                font-family: 'Quicksand', sans-serif;
                font-size: 16px;
                font-weight: 700;
              "
              >Name</label
            >
            <input
              type="text"
              class="form-control mb-3"
              placeholder="Name"
              required
              v-model="fullname"
            />
          </div>
          <div class="col-md-6 mt-3">
            <label
              style="
                font-family: 'Quicksand', sans-serif;
                font-size: 16px;
                font-weight: 700;
              "
              >Email</label
            >
            <input
              type="email"
              class="form-control mb-3"
              placeholder="Email"
              v-model="email"
              required
            />
          </div>

          <div class="col-md-6 mt-3">
            <label
              style="
                font-family: 'Quicksand', sans-serif;
                font-size: 16px;
                font-weight: 700;
              "
              >Phone</label
            >
            <input
              type="text"
              class="form-control mb-3"
              placeholder="Phone Number"
              v-model="phone"
              @keyup="formatt()"
              required
            />
          </div>

          <div class="col-md-12">
            <div class="row text-center mt-5">
              <div class="col-md-12">
                <label
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-size: 20px;
                    font-weight: 700;
                  "
                  >Bid Value ($)</label
                >
                <div class="flex items-center" style="margin: auto">
                  <button
                    type="button"
                    class="m-3 py-1 px-2 border-0"
                    style="
                      background-color: transparent;
                      font-size: 22px;
                      color: black;
                    "
                    @click="subtractCount()"
                  >
                    —
                  </button>
                  <span
                    class="text-center font-medium text-lg border w-16 rounded-lg py-2 px-2"
                    style="
                      font-family: 'Quicksand', sans-serif;
                      font-size: 20px;
                      font-weight: 700;
                    "
                    >{{ bidValue }}</span
                  >
                  <button
                    type="button"
                    class="m-3 py-1 px-2 border-0"
                    style="background-color: transparent; font-size: 22px"
                    @click="addCount()"
                  >
                    ＋
                  </button>
                </div>

                <label
                  class="mb-3"
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                  "
                  >Tap arrow to increase bid amount by increment</label
                >
              </div>
            </div>
          </div>
          <div class="col-md-12 text-center mt-4">
            <button
              @click="bidNow()"
              :disabled="
                !fullname.trim().length ||
                !invalidemail ||
                !invalidphone ||
                bidValue < Number(selected ? selected.currentBidValue : 0) ||
                isSubmitted
              "
              class="btn solid-btn-100BMODSouth m-auto mr-2"
              style="
                pointer-events: all;
                cursor: pointer;
                font-family: 'Montserrat', sans-serif;
                font-weight: 700;
                font-size: 1em;
                font-weight: bold;
              "
            >
              Bid Now
            </button>
          </div>
        </div>
      </div>
    </nu-modal>
    <!-- model -->

    <div class="container-fluid p-0" style="overflow-x: hidden">
      <!-- Navbar section starts -->
      <!-- <div class="row">
        <div class="col-md-12">
          <nav-bar />
        </div>
      </div> -->
      <!-- Navbar section ends -->

      <!-- banner section starts -->
      <div class="row text-center">
        <div class="col-md-12" id="banner">
          <img
            class="align-middle"
            src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/header_BlackMenofSouthMetro35thAnnualCelebrationofExcellenceScholarshipGalaMain_V1.png"
            style="width: 100%; max-width: 100%; height: auto"
          />
        </div>
      </div>
      <!-- banner section ends -->
      <div
        class="row w-100 m-0 promo-section MYLE-lite-green"
        style="background-color: #d8b146"
      >
        <div class="col-lg-12 col-md-12">
          <div class="mt-4">
            <div class="section-heading mb-4">
              <h1
                class="text-center"
                style="
                  font-family: 'nunito', sans-serif;
                  font-weight: 700;
                  color: #ffffff;
                "
              >
                100 Black Men of South Metro Atlanta 35th Annual Celebration of
                Excellence Scholarship Gala
              </h1>

              <h1
                class="text-center"
                style="
                  font-family: 'nunito', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                  color: #ffffff;
                "
              >
                🗓️ Saturday, April 26, 2025
                <br />
                ⏰ Starts at 5:00 PM
                <!-- - 11:00 PM -->
              </h1>

              <h1
                class="text-center"
                style="
                  font-family: 'nunito', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                  color: #ffffff;
                "
              >
                <a
                  href="https://maps.app.goo.gl/A3nGyqacWCbYXs3x7"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #ffffff"
                >
                  📍 Atlanta Airport Marriott Gateway
                  <br />
                  2020 Convention Center Concourse, Atlanta, GA 30337
                </a>
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div class="section-heading mb-0 p-3" style="background: #faf9f6">
        <div class="text-center">
          <a
            href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala#tickets"
            class="btn solid-btn-100BMODSouth ml-3 mr-3 mb-1 text-center"
            target="_self"
            style="
              font-family: 'Montserrat', sans-serif;
              font-weight: 700;
              font-size: 1em;
              font-weight: bold;
            "
            rel="noopener noreferrer"
            >Buy Tickets</a
          >

          <a
            href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala-raffle"
            class="btn solid-btn-100BMODSouth ml-3 mr-3 mb-1 text-center"
            target="_self"
            style="
              font-family: 'Montserrat', sans-serif;
              font-weight: 700;
              font-size: 1em;
              font-weight: bold;
            "
            rel="noopener noreferrer"
            >Buy Raffle Tickets</a
          >

          <a
            href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala-donation"
            class="btn solid-btn-100BMODSouth mb-1 ml-3 mr-3 text-center"
            target="_self"
            style="
              font-family: 'Montserrat', sans-serif;
              font-weight: 700;
              font-size: 1em;
              font-weight: bold;
            "
            >Donate</a
          >

          <a
            href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala-silent-auction"
            class="btn solid-btn-100BMODSouth mb-1 ml-3 mr-3 text-center"
            target="_self"
            style="
              font-family: 'Montserrat', sans-serif;
              font-weight: 700;
              font-size: 1em;
              font-weight: bold;
            "
            >Silent Auction</a
          >

          <a
            href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala#sponsorship"
            class="btn solid-btn-100BMODSouth mb-1 ml-3 mr-3 text-center"
            target="_self"
            style="
              font-family: 'Montserrat', sans-serif;
              font-weight: 700;
              font-size: 1em;
              font-weight: bold;
            "
            >Sponsorship</a
          >

          <!-- <a
              href="https://myle.com/2024-scholarship-gala-weekend"
              class="btn solid-btn-100blackmen-inverted mb-1 ml-3 mr-3 text-center"
              target="_self"
              >Back To Main Page</a
            > -->

          <!-- <a
              href="https://myle.com/scholarship-gala-benefitting-the-leadership-academy-silent-auction"
              class="btn solid-btn-100blackmen-inverted ml-3 mr-3 mb-1 text-center"
              target="_blank"
              rel="noopener noreferrer"
              >Silent Auction</a
            > -->
        </div>
      </div>

      <!-- Description section starts -->
      <div
        class="row align-items-center justify-content-between test text-center mb-4"
        style="margin: auto; margin-top: 20px"
      >
        <div class="col-md-12">
          <div class="col-md-12">
            <!-- <div class="download-content">
                <p
                  class=""
                  style="
                    font-family: 'nunito', sans-serif;
                    font-size: 1.6em;
                    color: #0b3048;
                  "
                >
                  Support the JL Tillman Scholarship through the Awards Gala
                  Silent Auction.
                </p>
              </div> -->
          </div>
        </div>
      </div>

      <!-- <div class="section-heading mb-2 mt-5">
              <div class="text-center">
                <a
                  href="https://myle.com/100-black-men-of-dekalb-county"
                  class="btn solid-btn-100blackmen mb-1 text-center"
                  target="_self"
                  >Back To Main Page
                </a>
              </div>
            </div> -->

      <div class="row col-md-12">
        <div class="flexcontainer">
          <div v-bind:key="objk" v-for="(obj, objk) in list">
            <div
              class="card"
              style="
                width: 400px;
                border-radius: 10px;
                overflow: hidden;
                box-shadow: 0px 0px 4px 4px #d8b146;
              "
            >
              <div
                class="card-body"
                style="display: flex; flex-direction: column; width: 100%"
              >
                <img
                  style="width: 100%; height: 20rem; object-fit: scale-down"
                  :src="
                    'https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/' +
                    obj.image
                  "
                />
                <div
                  class="text-center mt-2"
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-size: 20px;
                    font-weight: 500;
                    color: black;
                    min-height: 4.5rem;
                    line-height: 1.5rem;
                  "
                >
                  {{ obj.title }}
                </div>

                <div class="mt-2 flex d-flex justify-content-between">
                  <div>
                    <strong
                      style="
                        color: black;
                        font-family: 'Quicksand', sans-serif;
                        font-size: 18px;
                        font-weight: 700;
                      "
                      >Current Bid</strong
                    >
                    <p
                      style="
                        font-size: 14px;
                        text-align: center;
                        font-family: 'Quicksand', sans-serif;
                        font-size: 16px;
                        font-weight: 500;
                      "
                    >
                      ${{ obj.currentBidValue }}
                    </p>
                  </div>

                  <div>
                    <strong
                      style="
                        color: black;
                        font-family: 'Quicksand', sans-serif;
                        font-size: 18px;
                        font-weight: 700;
                      "
                      >Time Remaining</strong
                    >
                    <p
                      style="
                        text-align: center;
                        font-family: 'Quicksand', sans-serif;
                        font-size: 16px;
                        font-weight: 500;
                      "
                    >
                      {{
                        calculateDays(
                          obj.auctionStartDateTime,
                          obj.auctionEndDateTime
                        )
                      }}
                      day(s)
                    </p>
                  </div>
                </div>

                <div class="text-center mb-4">
                  <label
                    style="
                      text-align: center;
                      font-family: 'Quicksand', sans-serif;
                      font-size: 16px;
                      font-weight: 500;
                    "
                    ><strong> ({{ obj.totalBids }})</strong> Bid(s)</label
                  >
                </div>

                <hr style="margin: 0; margin-bottom: 17px" />

                <div class="text-center">
                  <button
                    type="button"
                    :disabled="obj.status !== 'ACTIVE'"
                    class="btn solid-btn-100BMODSouth my-auto"
                    style="
                      font-family: 'Montserrat', sans-serif;
                      font-weight: 700;
                      font-size: 1em;
                      font-weight: bold;
                    "
                    @click="openModel(obj)"
                  >
                    Place Your Bid
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div
          class="row align-items-center justify-content-between test"
          style="margin: auto"
        >
          <div class="col-md-12">
            <div class="col-md-12">
              <div class="download-content">
                <p
                  class="mb-0"
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 700;
                    font-size: 22px;
                  "
                >
                  Silent Auction Guidelines:
                </p>
                <p
                  class=""
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 500;
                    font-size: 18px;
                  "
                >
                  1. The Silent Auction will end at 8:30pm today, October 12,
                  2023<br />
                  2. The highest bidder at the end of the auction will win the
                  selected item<br />
                  3. Winners will be announced at the Gala and also informed via
                  email notification<br />
                  4. All winners will be required to pay for their item by 9pm ET
                  to avoid forfeiting their bid to the runner up. If you choose to
                  have your item shipped, you'll be invoiced for shipping<br />
                  5. Winners will be contacted via email with a link to pay for
                  their item online or they may visit the Auction Check-Out Table
                  at the Gala for assistance with their payment. Winners should
                  pay by 9:30pm<br />
                  <br />
                  Have a question? Visit us at the Auction Check-Out Table and we
                  will be happy to assist you.
                </p>
              </div>
            </div>
          </div>
        </div> -->

      <!-- <div class="section-heading mb-2">
            <div class="text-center">
              <a
                href="https://myle.com/100-black-men-of-dekalb-county"
                class="btn solid-btn-100blackmen mb-1 ml-3 mr-3 text-center"
                target="_self"
                >Back To Main Page</a
              >
    
              <a
                href="https://myle.com/scholarship-gala-donations"
                class="btn solid-btn-100blackmen ml-3 mr-3 mb-1 text-center"
                target="_blank"
                rel="noopener noreferrer"
                >Donations</a
              >
            </div>
          </div> -->
    </div>

    <!-- <div
      class="row w-100 m-0 promo-section MYLE-lite-green"
      style="background-color: #2162ac"
    >
      <div class="col-lg-12 col-md-12">
        <div class="mt-5">
          <div class="section-heading mb-5">
            <h2
              class="text-center"
              style="
                font-family: 'nunito', sans-serif;
                font-weight: 700;
                color: #ffffff;
              "
            >
              Download today and try it for yourself
            </h2>
            <div
              class="download-btn mt-4 text-center animate__animated animate__fadeIn"
            >
              <a
                href=" https://apps.apple.com/us/app/myle-create-discover-events-curated-for-you/id1162354481"
                class="btn google-play-btn mr-3"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-apple"></span> App Store</a
              >
              <a
                href="https://play.google.com/store/apps/details?id=xyz.getmyle.myle&hl=en&gl=US"
                class="btn google-play-btn mr-3"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-android"></span> Google Play</a
              >
              <a
                href="https://web.myle.com"
                class="btn google-play-btn"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-world"></span> MYLE Web</a
              >
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <br />
    <div class="section-heading mb-0 p-3 mt-5" style="background: #faf9f6">
      <div class="text-center">
        <a
          href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala#tickets"
          class="btn solid-btn-100BMODSouth ml-3 mr-3 mb-1 text-center"
          target="_self"
          style="
            font-family: 'Montserrat', sans-serif;
            font-weight: 700;
            font-size: 1em;
            font-weight: bold;
          "
          rel="noopener noreferrer"
          >Buy Tickets</a
        >

        <a
          href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala-raffle"
          class="btn solid-btn-100BMODSouth ml-3 mr-3 mb-1 text-center"
          target="_self"
          style="
            font-family: 'Montserrat', sans-serif;
            font-weight: 700;
            font-size: 1em;
            font-weight: bold;
          "
          rel="noopener noreferrer"
          >Buy Raffle Tickets</a
        >

        <a
          href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala-donation"
          class="btn solid-btn-100BMODSouth mb-1 ml-3 mr-3 text-center"
          target="_self"
          style="
            font-family: 'Montserrat', sans-serif;
            font-weight: 700;
            font-size: 1em;
            font-weight: bold;
          "
          >Donate</a
        >

        <a
          href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala-silent-auction"
          class="btn solid-btn-100BMODSouth mb-1 ml-3 mr-3 text-center"
          target="_self"
          style="
            font-family: 'Montserrat', sans-serif;
            font-weight: 700;
            font-size: 1em;
            font-weight: bold;
          "
          >Silent Auction</a
        >

        <a
          href="https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala#sponsorship"
          class="btn solid-btn-100BMODSouth mb-1 ml-3 mr-3 text-center"
          target="_self"
          style="
            font-family: 'Montserrat', sans-serif;
            font-weight: 700;
            font-size: 1em;
            font-weight: bold;
          "
          >Sponsorship</a
        >

        <!-- <a
            href="https://myle.com/2024-scholarship-gala-weekend"
            class="btn solid-btn-100blackmen-inverted mb-1 ml-3 mr-3 text-center"
            target="_self"
            >Back To Main Page</a
          > -->

        <!-- <a
            href="https://myle.com/scholarship-gala-benefitting-the-leadership-academy-silent-auction"
            class="btn solid-btn-100blackmen-inverted ml-3 mr-3 mb-1 text-center"
            target="_blank"
            rel="noopener noreferrer"
            >Silent Auction</a
          > -->
      </div>
    </div>

    <div class="row w-100 m-0 promo-section">
      <div class="col-lg-12 col-md-12 mt-0">
        <div class="mt-5">
          <div class="section-heading mb-5">
            <h2
              class="text-center"
              style="
                font-family: 'Quicksand', sans-serif;
                font-weight: 500;
                font-size: 15px;
              "
            >
              Powered by <a target="_blank" href="https://myle.com/">MYLE</a>
            </h2>
          </div>
        </div>
      </div>
    </div>
    <!-- <site-footer :show-subscribe="true" /> -->
  </div>
</template>

<script>
// import NavBar from "../../../views/commons/NavBar";
// import SiteFooter from "../../../views/index-five/SiteFooter";
import axios from "axios";
import VueElementLoading from "vue-element-loading";

// tslint-disable no-mixed-spaces-and-tabs
export default {
  name: "newyear",
  data() {
    return {
      selected: null,
      email: "",
      phone: "",
      bidValue: "",
      fullname: "",
      list: [],
      isSubmitted: false,
      loadStyle: {
        color: "#ffffff",
        "font-weight": "bold",
        "letter-spacing": "1rem",
        "font-size": "18px",
      },
    };
  },
  components: {
    // NavBar,
    // SiteFooter,
    VueElementLoading,
  },
  methods: {
    formatt() {
      let newValue = this.phone;
      if (this.phone.startsWith("+") && !newValue.startsWith("+1 (")) {
        newValue = newValue.slice(1);
      }
      let updatedValue = "";
      const match = newValue.match(/^[0-9+]/g);
      if (!match) {
        updatedValue = newValue.slice(0, -1);
        return updatedValue;
      }
      if (newValue.startsWith("+1 (")) {
        newValue = newValue.slice(4, newValue.length);
      }
      if (newValue.length >= 1 && !isNaN(parseInt(newValue[0]))) {
        var x = newValue
          .replace(/\D/g, "")
          .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        updatedValue = !x[2]
          ? x[1]
          : "+1 (" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
      } else {
        updatedValue = newValue;
      }

      this.phone = updatedValue;
    },
    subtractCount() {
      if (
        this.bidValue -
          (this.selected ? Number(this.selected.incrementValue || 1) : 1) >=
        (this.selected
          ? Number(this.selected.currentBidValue) +
            Number(this.selected.incrementValue || 0)
          : 0)
      ) {
        this.bidValue -= this.selected
          ? Number(this.selected.incrementValue || 1)
          : 1;
      }
    },
    addCount() {
      this.bidValue += this.selected
        ? Number(this.selected.incrementValue || 1)
        : 1;
    },
    calculateDays(d1, d2) {
      const dat = new Date();

      let date1 = new Date(d1);
      if (dat.getTime() > date1.getTime()) {
        date1 = dat;
      } else {
        date1 = new Date(d1);
      }
      const date2 = new Date(d2);
      const Difference_In_Time = date2.getTime() - date1.getTime();
      const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      return dat.getTime() > date2.getTime()
        ? 0
        : Math.ceil(Difference_In_Days);
    },
    openModel(obj) {
      this.email = "";
      this.bidValue = Number(obj.currentBidValue) + Number(obj.incrementValue);
      this.fullname = "";
      this.phone = "";
      this.selected = null;
      setTimeout(() => {
        this.selected = { ...obj };
        this.$refs.zmodal.open();
      }, 500);
    },
    bidNow() {
      const req =
        "https://myle-19701.uc.r.appspot.com/api/auction_item_bidding";
      const self = this;
      self.isSubmitted = true;

      axios
        .post(req, {
          itemCode: self.selected.itemCode,
          name: self.fullname,
          email: self.email.toLowerCase(),
          bidValue: self.bidValue,
          phone: this.phone,
        })
        .then(() => {
          self.phone = "";
          self.email = "";
          self.fullname = "";
          self.bidValue = "";
          self.selected = null;
          self.$refs.zmodal.close();
          self.getAutionItems();
        })
        .catch((err) => {
          if (
            err &&
            err.response &&
            err.response.data &&
            err.response.data.Message
          ) {
            self.$toast.error(err.response.data.Message, { timeout: 4000 });
          }
        })
        .finally(() => {
          self.isSubmitted = false;
        });
    },
    getAutionItems(s) {
      const req = "https://myle-19701.uc.r.appspot.com/api/get_auction_items";
      const self = this;
      self.isSubmitted = true;

      axios
        .post(req, {
          eventId: "E4BegYG9no9uPd",
        })

        .then((res) => {
          if (res && res.data && res.data.Result) {
            self.list = res.data.Result;

            self.list.map((ee) => {
              if (s && ee.itemCode === s) {
                this.openModel(ee);
              }
            });
          }
        })
        .finally(() => {
          self.isSubmitted = false;
        });
    },
  },
  mounted() {
    const self = this;
    console.log(this.$route.query);
    self.getAutionItems(this.$route.query.itm);
  },
  computed: {
    invalidemail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.email);
    },
    invalidphone() {
      return (this.phone || "").trim().length >= 10;
    },
  },
  metaInfo: {
    title:
      "MYLE - 100 Black Men of South Metro Atlanta 35th Annual Celebration of Excellence Scholarship Gala - Silent Auction",

    meta: [
      {
        name: "description",
        content:
          "MYLE - 100 Black Men of South Metro Atlanta 35th Annual Celebration of Excellence Scholarship Gala - Silent Auction",
      },

      {
        name: "keywords",
        content:
          "MYLE - 100 Black Men of South Metro Atlanta 35th Annual Celebration of Excellence Scholarship Gala - Silent Auction",
      },

      {
        name: "copyright",
        content: "MYLE",
      },

      {
        name: "url",
        content:
          "https://myle.com/100-black-men-of-south-metro-35th-annual-celebration-of-excellence-scholarship-gala-silent-auction",
      },
    ],
  },
};
</script>

<style scoped>
#reserve {
  color: white;
}
#reserve:hover {
  color: #104233;
}
.background-overlay {
  background: #114436c4 !important;
  max-width: 100%;
  z-index: 9999 !important;
}
#banner {
  background-size: cover;
}
.innerimg {
  margin: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;
  max-width: 80%;
  height: auto;
  border: 1px double #d7c57d;
}

.bg-disable {
  background: pink;
  border: 1px solid pink;
  color: red !important;
  pointer-events: none;
}

@media (max-width: 768px) {
  #redeem {
    text-align: center;
  }
}

@media (max-width: 922px) {
  #d2 {
    overflow-x: scroll;
  }
}
@media (min-width: 922.1px) {
  #d2 {
    overflow-x: hidden;
  }
}

@media (max-width: 450px) {
  .card {
    width: auto !important;
  }
}

hr.dashed {
  border-top: 3px solid;
}

.flexcontainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  width: 90%;
  margin: auto;
  justify-content: center;
  margin-bottom: 2rem;
}
</style>
